import React, { FC } from "react"
import { useDispatch } from "react-redux"
import { CustomInput } from "reactstrap"
import { v4 } from "uuid"
import { GuiData } from 'web/data/gui-data'
import { RosterActions, useRosterState } from "web/redux/slices/roster-slice"
import { createGroupedOptions } from "web/utils/jsx-utils"
import { getCurrentBuild } from 'web/data/core-data'
import { ModalActions } from 'web/redux/slices/modal-slice'

export const CreateRosterPlayerSidebar: FC = () => {

    const disp = useDispatch()
    const specOptions = createGroupedOptions({ optionGroups: GuiData.PlayerSpecOptions })

    const buildData = getCurrentBuild()

    const rosterState = useRosterState()
    const rosterPlayerNames = rosterState.players.map(player => player.name)

    const addPlayer = (specId: string) => {
        disp(ModalActions.openEditPlayerModal({
            mode: "roster-add",
            title: "Add player",
            saveBtnText: "Add player",
            rosterPlayerNames,
            player: {
                specId,
                id: v4(),
                name: '',
                modifierIds: [],
                overrides: [],
                talentIds: [],
                patchInfo: buildData.patchInfo,
            },
            onConfirm: (player) => {
                disp(RosterActions.addPlayer({ player }))
            }
        }))
    }

    return (
        <div className="d-flex flex-column space-my-3" style={{ width: "282px" }}>
            <label>{"Create player"}</label>

            <div className="d-flex flex-column">
                <label className="font-weight-bold small">{"Spec"}</label>
                <CustomInput
                    id="player-spec-select"
                    bsSize="sm"
                    type="select"
                    value={''} // Never used
                    onChange={(e) => {
                        addPlayer(e.target.value)
                    }}
                >

                    <option value="">{"-- Select spec --"}</option>
                    {specOptions}

                </CustomInput>
            </div>
        </div>
    )
}
